var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJetCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "matrix(-1 0 0 1 17 0.5)",
    fill: "#22428F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8442 3.56752C13.9669 3.66574 14.0172 3.79669 13.9948 3.96038L12.5663 13.389C12.5477 13.5076 12.4882 13.5997 12.3877 13.6652C12.3357 13.6979 12.278 13.7143 12.2147 13.7143C12.1738 13.7143 12.1292 13.7041 12.0808 13.6836L9.55297 12.548L8.20255 14.3588C8.13559 14.4529 8.04444 14.5 7.92912 14.5C7.88075 14.5 7.83983 14.4918 7.80635 14.4754C7.73567 14.4468 7.67894 14.3987 7.63615 14.3312C7.59337 14.2637 7.57198 14.189 7.57198 14.1071V11.9648L12.3933 5.46429L6.42803 11.1423L4.22383 10.1479C4.08618 10.0906 4.01178 9.97805 4.00062 9.81027C3.99318 9.64658 4.0527 9.52586 4.17919 9.4481L13.4647 3.55525C13.5205 3.51842 13.5801 3.5 13.6433 3.5C13.7177 3.5 13.7847 3.52251 13.8442 3.56752Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetCircle);
export default __webpack_public_path__ + "static/media/jet-circle.6105bbc332c98181c55d946d2e569808.svg";
export { ForwardRef as ReactComponent };